export const fmtMoney = (n) =>
  (Number(n) || 0).toLocaleString("en-LK", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const fmtRs = (n) => `Rs. ${fmtMoney(n)}`;
